module.exports = __webpack_public_path__ + "media/images/defaultactivities-d3b2e231.png";